<template>
  <div class="upload-avatar-page">
    <!-- 白色卡片容器 -->
    <div class="avatar-card">
      <div class="avatar-back status-bar-safe-with-offset">
        <BackButton />
      </div>
      <!-- 头像显示区域 -->
      <div class="avatar-section">
        <var-avatar :src="avatarUrl" size="120" class="avatar-display">
          <!-- 默认头像图标 -->
          <var-icon name="account" size="60" v-if="!avatarUrl" />
        </var-avatar>

        <!-- 标题 -->
        <h2 class="upload-title">{{ $t('uploadAvatar.title') }}</h2>
      </div>

      <!-- 上传区域 -->
      <div class="upload-section">
        <!-- 虚线框上传区域 -->
        <div class="upload-area">
          <!-- 上传组件 -->
          <var-uploader
            v-model="fileList"
            :maxsize="5 * 1024 * 1024"
            accept="image/*"
            @after-read="handleAfterRead"
            @oversize="handleOversize"
            hide-list
            class="uploader-component"
          >
            <!-- 上传图标 -->
              <!-- <CustonIcon name="upload" size="40" /> -->
            <!-- <div class="upload-icon">
              <CustonIcon
                :config="{
                  attr: {
                    cic_tp: 1,
                    cic_sz: 40,
                    cic_url: 'upload-1',
                    cic_c: 'var(--color-text)',
                  },
                }"
              />
            </div> -->
            <div class="choose-file-btn">
              {{ avatarUrl ? $t('uploadAvatar.rechoose') : $t('uploadAvatar.choose') }}
            </div>
          </var-uploader>

          <!-- 移除头像按钮 -->
          <div v-if="avatarUrl" class="remove-avatar-btn" @click="removeAvatar">
            <var-icon name="delete" size="20" />
            {{ $t('uploadAvatar.remove') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { toast } from 'd3components/src/utils/tools';
import { updateUserInfo } from 'd3components/src/api/user';
import { useI18n } from 'vue-i18n';
import BackButton from '@/layout/components/backbutton.vue';
import CustonIcon from 'd3components/src/components/item-d3/d3/d3_customIcon.vue';
const { t } = useI18n({ useScope: 'global' });

// 头像URL
const avatarUrl = ref('');

// 文件列表
const fileList = ref([]);

// 上传中状态
const uploading = ref(false);
// 处理文件读取完成
const handleAfterRead = async (file) => {
  console.log('文件读取完成:', file);
  console.log(file.file);
  console.log(file.file instanceof File);
  // 清理之前的URL，避免内存泄漏
  if (avatarUrl.value && avatarUrl.value.startsWith('blob:')) {
    URL.revokeObjectURL(avatarUrl.value);
  }

  // 创建文件预览URL
  if (file.file) {
    avatarUrl.value = URL.createObjectURL(file.file);

    // 上传头像到服务器
    await uploadAvatar(file.file);
  } else {
    toast(t('uploadAvatar.uploadSuccess'), 1);
  }
};

// 上传头像到服务器
const uploadAvatar = async (file) => {
  try {
    const formData = new FormData();

    formData.append('shownava', file, file.name);

    const res = await updateUserInfo(formData);

    console.log(res);
    // const { code, value } = await updateUserInfo(formData)

    if (code === 0) {
      toast(t('uploadAvatar.uploadSuccess'), 1);
    } else {
      toast(`${t('uploadAvatar.uploadFailed')}: ${value}`, 3);
    }
  } catch (error) {
    console.error(error);
  } finally {
    uploading.value = false;
  }
};

// 处理文件超出大小限制
const handleOversize = () => {
  toast(t('uploadAvatar.fileTooLarge'), 3);
};

// 移除头像
const removeAvatar = () => {
  // 清理URL，避免内存泄漏
  if (avatarUrl.value && avatarUrl.value.startsWith('blob:')) {
    URL.revokeObjectURL(avatarUrl.value);
  }

  // 重置状态
  avatarUrl.value = '';
  fileList.value = [];

  toast(t('uploadAvatar.removed'), 1);
};
</script>

<style lang="scss" scoped>
.upload-avatar-page {
  height: 100%;
  background-color: var(--color-body);
}

.avatar-card {
  width: 100%;
  text-align: center;
  background-color: var(--color-on-info);
}
.avatar-back {
  padding: 25px 35px;  //（非微信环境）
}

.is-wechat .avatar-back {
  padding-left: 10px;  // 微信环境覆盖
}
.avatar-section {
  margin-bottom: 60px;

  .avatar-display {
    margin-top: 10px;
    margin-bottom: 30px;

    :deep(.var-avatar__image) {
      border-radius: 50%;
    }

    :deep(.var-icon) {
      color: var(--color-on-surface-variant);
    }
  }

  .upload-title {
    font-size: 28px;
    font-weight: 600;
    color: var(--color-text);
    margin: 0;
  }
}

.upload-section {
  .upload-area {
    border: 2px dashed var(--color-outline);
    border-radius: 12px;
    padding: 50px 20px;
    transition: all 0.3s ease;
    position: relative;

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        border-color: hsla(var(--hsl-text), 0.28);
      }
    }

    .upload-icon {
      margin-bottom: 20px;

      :deep(.var-icon) {
        color: var(--color-on-surface-variant);
      }
    }

    .uploader-component {
      // margin-bottom: 20px;

      :deep(.var-uploader__file-list) {
        justify-content: center;
      }

      .choose-file-btn {
        border: 1px solid var(--color-outline);
        border-radius: 8px;
        padding: 12px 24px;
        font-size: 24px;
        color: var(--color-text);
        cursor: pointer;
        transition: all 0.3s ease;
        display: inline-block;

        @media (hover: hover) and (pointer: fine) {
          &:hover {
            border-color: hsla(var(--hsl-text), 0.28);
          }
        }

        &:active {
          transform: translateY(1px);
        }
      }
    }

    .remove-avatar-btn {
      background: #ff4757;
      color: white;
      border: none;
      border-radius: 8px;
      padding: 10px 20px;
      font-size: 24px;
      cursor: pointer;
      transition: all 0.3s ease;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      margin-top: 15px;

      &:hover {
        background: #ff3742;
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }

      :deep(.var-icon) {
        font-size: 16px;
      }
    }
  }
}
.needs-status-bar-adaptation .status-bar-safe-with-offset {
  // padding-top: var(--header-safe-padding-top) !important;
}
// Varlet UI 组件样式覆盖
:deep(.var-uploader) {
  .var-uploader__input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}
</style>